import { images } from "../../constants";

export default [
        {
        image: images.london,
        trip: "London Trip",
        tripPackage: "Christmas in london",
        country: "GB",
        startDate: "22 DEC",
        endDate: "28 DEC",
        price: "1000000",
        upcoming: false,
        favorite: false,
        promotions: "",
    },
    {
        image: images.dubai,
        trip: "Dubai Trip",
        tripPackage: "6 days in dubai",
        country: "AE",
        startDate: "08 DEC",
        endDate: "13 DEC",
        price: "1400000",
        upcoming: true,
        favorite: true,
        promotions: "30% OFF",
    },
    {
        image: images.paris,
        trip: "Paris Trip",
        tripPackage: "7 days in paris",
        country: "FR",
        startDate: "02 MAR",
        endDate: "08 MAR",
        price: "800000",
        upcoming: false,
        favorite: false,
        promotions: "10% OFF",
    },
    {
        image: images.dubai,
        trip: "Dubai Trip",
        tripPackage: "6 days in dubai",
        country: "AE",
        startDate: "08 DEC",
        endDate: "13 DEC",
        price: "1400000",
        upcoming: true,
        favorite: true,
        promotions: "30% OFF",
    },
    {
        image: images.paris,
        trip: "Paris Trip",
        tripPackage: "7 days in paris",
        country: "FR",
        startDate: "02 MAR",
        endDate: "08 MAR",
        price: "800000",
        upcoming: false,
        favorite: false,
        promotions: "10% OFF",
    },
    {
        image: images.london,
        trip: "London Trip",
        tripPackage: "Christmas in london",
        country: "GB",
        startDate: "22 DEC",
        endDate: "28 DEC",
        price: "1000000",
        upcoming: false,
        favorite: false,
        promotions: "",
    },
]